import { render } from "./ListiniDataTable.vue?vue&type=template&id=46de7d53&scoped=true"
import script from "./ListiniDataTable.vue?vue&type=script&lang=js"
export * from "./ListiniDataTable.vue?vue&type=script&lang=js"

import "./ListiniDataTable.vue?vue&type=style&index=0&id=46de7d53&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46de7d53"]])

export default __exports__